import React from "react";
import { FaFilter, FaTimes } from "react-icons/fa";

import {
  EVENT_CATEGORIES,
  EVENT_LEVELS,
  EVENT_TYPES,
} from "../utils/eventsJudokaUtils";

function SelectField({ label, value, onChange, options, placeholder }) {
  return (
    <div>
      <label className="mb-2 block text-xs font-bold uppercase tracking-[0.16em] text-slate-400">
        {label}
      </label>

      <select
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="min-h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-semibold text-slate-900 outline-none transition focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-500/10 dark:border-white/10 dark:bg-white/[0.06] dark:text-white"
      >
        <option value="">{placeholder}</option>

        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
}

function EventFilters({ filters, onFilterChange, onReset }) {
  const timeTabs = [
    { id: "upcoming", label: "À venir" },
    { id: "past", label: "Passés" },
    { id: "all", label: "Tous" },
  ];

  const hasFilters =
    filters.type_event ||
    filters.cate_event ||
    filters.level_event ||
    filters.time_event !== "upcoming";

  return (
    <div className="mb-6 rounded-[2rem] border border-slate-200 bg-white p-4 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20 sm:p-6">
      <div className="mb-5 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-orange-100 text-orange-700 dark:bg-orange-500/10 dark:text-orange-200">
            <FaFilter />
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400">
              Filtres
            </p>

            <h2 className="font-titre text-xl font-bold text-slate-950 dark:text-white">
              Affiner les événements
            </h2>
          </div>
        </div>

        {hasFilters && (
          <button
            type="button"
            onClick={onReset}
            className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-2 text-sm font-bold text-slate-700 transition hover:bg-white hover:shadow-md dark:border-white/10 dark:bg-white/[0.07] dark:text-white"
          >
            <FaTimes className="text-xs" />
            Réinitialiser
          </button>
        )}
      </div>

      <div className="mb-5 grid gap-2 rounded-[1.5rem] border border-slate-200 bg-slate-50 p-2 dark:border-white/10 dark:bg-white/[0.03] sm:grid-cols-3">
        {timeTabs.map((tab) => {
          const isActive = filters.time_event === tab.id;

          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onFilterChange("time_event", tab.id)}
              className={`min-h-11 rounded-[1.1rem] px-4 py-2 text-sm font-bold transition ${
                isActive
                  ? "bg-slate-950 text-white shadow-lg dark:bg-white dark:text-slate-950"
                  : "text-slate-600 hover:bg-white dark:text-white/60 dark:hover:bg-white/10"
              }`}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        <SelectField
          label="Type"
          value={filters.type_event}
          onChange={(value) => onFilterChange("type_event", value)}
          options={EVENT_TYPES}
          placeholder="Tous les types"
        />

        <SelectField
          label="Catégorie"
          value={filters.cate_event}
          onChange={(value) => onFilterChange("cate_event", value)}
          options={EVENT_CATEGORIES}
          placeholder="Toutes les catégories"
        />

        <SelectField
          label="Niveau"
          value={filters.level_event}
          onChange={(value) => onFilterChange("level_event", value)}
          options={EVENT_LEVELS}
          placeholder="Tous les niveaux"
        />
      </div>
    </div>
  );
}

export default EventFilters;